import React, { useState, useEffect, useRef } from "react";
import { FormattedMessage } from "react-intl";
import OrderCategory from "../../components/tables/OrderCategory";
import OrderServiceType from "../../components/tables/OrderServiceType";
import { useIntl } from "react-intl";
import {
  EditOutlined,
  FileDoneOutlined,
  CalendarOutlined,
  PrinterOutlined,
  DownOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  MailOutlined,
  CopyOutlined,
  ScheduleOutlined,
} from "@ant-design/icons";
import { Button, Modal, Badge, Tag, Menu, Typography, Dropdown } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { reload, loadPage, reset as resetPage } from "./OrdersSlice";
import {
  setActiveOrder,
  removeOrder,
  reset,
} from "../orderDetails/OrderDetailsSlice";
import { useUserBranches } from "../../hooks/accessControl";
import {
  useRelativeTypes,
  useOrderServiceTypes,
  useProfessionalRoles,
} from "../../hooks";
import {
  getStartOfTromFile,
  getReportedTromFile,
} from "../../components/print/printSections/trom";
import ActionsTable from "../../components/templates/ActionsTable";
import Date from "../../components/tables/Date";
import OrderHours from "../../components/tables/OrderHours";
import Order from "../orderDetails/index";
import Surface from "../../components/layouts/Surface";
import EmptyState from "../../components/templates/EmptyState";
import { ReactComponent as OrderImg } from "../../assets/no-orders.svg";
import moment from "moment";
import EndOrderModal from "./components/EndOrderModal";
import OrderPlanModal from "./components/OrderPlanModal";
import StartOfTromModal from "./components/StartOfTromModal";
import ReportedTromModal from "./components/ReportedTromModal";
import PlanModal from "./components/PlanModal";
import ChangeLogModal from "./components/ChangeLogModal";
import { useReactToPrint } from "react-to-print";
import { useLocation } from "react-router-dom";
import PrintOrder from "../orderDetails/print/PrintOrder";
import useDebounce from "../../components/util/useDebounce";
import { useIsMount } from "../../hooks";
import {
  listScheduling,
  getEmployee,
  getOrderChangelog,
} from "../../api/server";
import { getFullName } from "../../components/util/helpers";

const { Text } = Typography;

const Orders = () => {
  const dispatch = useDispatch();
  let location = useLocation();
  const componentRef = useRef();
  const isfirstRender = useIsMount();
  const userBranches = useUserBranches();
  const relative_types = useRelativeTypes();
  const serviceTypes = useOrderServiceTypes();
  const professionalRoles = useProfessionalRoles();
  const [modal, contextHolder] = Modal.useModal();
  const [sortedItems, setSortedItems] = useState([]);
  const [visible, setVisible] = useState(false);
  const [activePatientId, setActivePatientId] = useState(null);
  const [endModalVisible, setEndModalVisible] = useState(false);
  const [planModalVisible, setPlanModalVisible] = useState(false);
  const [startOfTromVisible, setStartOfTromVisible] = useState(false);
  const [orderPlanlVisible, setOrderPlanlVisible] = useState(false);
  const [reportedTromVisible, setReportedTromVisible] = useState(false);
  const [changeLogVisible, setchangeLogVisible] = useState(false);
  const [orderChangeLogs, setOrderChangeLogs] = useState([]);

  const [mainContact, setMainContact] = useState(null);
  const [employeeName, setEmployeeName] = useState(null);
  const [employeeRole, setEmployeeRole] = useState(null);
  const [search, setSearch] = useState("");
  const debounceVal = search.length > 0 ? 0 : 400;
  const debouncedSearch = useDebounce(search, debounceVal);
  const [type, setType] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [tromScheduling, setTromScheduling] = useState([]);
  const organization = useSelector((state) => state.organization.details);

  const { page: ordersPage } = useSelector((state) => state.orders);
  const { current, pageSize, total, items, filter } = ordersPage;
  const loading = useSelector(
    (state) => state.pendingActions["orders/loadPage"]
  );
  const activePatient = useSelector(
    (state) => state.patientDetails.activePatient
  );
  const scopePrefix = useSelector((state) => state.user.scopePrefix);
  const intl = useIntl();
  useEffect(() => {
    let sorted = [];
    items.forEach((item, i) => {
      if (!item.effective_to || moment(item.effective_to) > moment()) {
        sorted.push({ ...item, activeStatus: true });
      } else {
        sorted.push({ ...item, activeStatus: false });
      }
    });
    setSortedItems(sorted.sort((a, b) => b.activeStatus - a.activeStatus));
  }, [items]);

  useEffect(() => {
    if (!isfirstRender) {
      dispatch(
        loadPage({
          current: 1,
          filter: { ...filter, freeText: debouncedSearch },
        })
      );
    }
  }, [debouncedSearch, dispatch]);

  useEffect(() => {
    if (activePatient.id && activePatientId !== activePatient.id) {
      if (isfirstRender) {
        dispatch(loadPage());
      }
      setActivePatientId(activePatient.id);
    }
  }, [dispatch, activePatient.id]);

  useEffect(() => {
    if (activePatient && activePatient.relatives.length > 0) {
      const main = activePatient.relatives.filter(
        (i) => i.main_contact === true
      )[0];
      setMainContact(main);
      if (main) {
        const selected = relative_types.filter(
          (item) => item.id === main["relative_type_id"]
        )[0];
        if (selected) {
          setType(selected["name"]);
        }
      }
    }
  }, [relative_types, activePatient]);

  const onEditClicked = (record) => {
    setSelectedOrder(record);
    setType("edit");
    setVisible(true);
  };

  const onDuplicateClicked = (record) => {
    setSelectedOrder(record);
    setType("duplicate");
    setVisible(true);
  };

  const onSendStartOfTrom = (record) => {
    setSelectedOrder(record);
    setStartOfTromVisible(true);
  };

  const onHideReportedTrom = (record) => {
    setReportedTromVisible(false);
    setSelectedOrder(null);
  };

  const onHideChangeLogModal = () => {
    setchangeLogVisible(false);
    setSelectedOrder(null);
    setSelectedOrder(null);
  };

  const onSendAppendixB = async (record) => {
    setSelectedOrder(record);
    await listTromScheduling(record);
    setTimeout(() => setReportedTromVisible(true), 100);
  };

  const onHideStartOfTromModal = () => {
    setStartOfTromVisible(false);
    setSelectedOrder(null);
    dispatch(reset());
  };

  const onEndOrderClicked = (record) => {
    setSelectedOrder(record);
    dispatch(
      setActiveOrder({
        record: record,
      })
    );
    setEndModalVisible(true);
  };
  const onHideEndModal = () => {
    setEndModalVisible(false);
    setSelectedOrder(null);
    dispatch(reset());
  };

  const onShowPlanClicked = (record) => {
    setSelectedOrder(record);
    setOrderPlanlVisible(true);
  };

  const onHideOrderPlanModal = () => {
    setOrderPlanlVisible(false);
    setSelectedOrder(null);
    dispatch(reset());
  };

  const onEditPlanClick = () => {
    setPlanModalVisible(true);
  };

  const onHidePlanModal = () => {
    setPlanModalVisible(false);
    setSelectedOrder(null);
    dispatch(reset());
    dispatch(loadPage());
  };

  const onTextChange = (e) => {
    setSearch(e.target.value);
  };

  const onAddClick = () => {
    if (
      process.env.REACT_APP_CONFIG === "matav" &&
      !activePatient.staff_worker_in_charge_id
    ) {
      modal.info({
        title: intl.formatMessage({
          id: "app.orders.can_not_create_order_title",
        }),
        content: (
          <div>
            <p style={{ margin: 0 }}>
              {intl.formatMessage({
                id: "app.orders.can_not_create_order_description",
              })}
            </p>
            <p style={{ color: "red" }}>
              {intl.formatMessage({
                id: "app.forms.patient.staff_worker_in_charge_id",
              })}
            </p>
          </div>
        ),
        onOk() {},
      });
    } else {
      setType("new");
      setVisible(true);
    }
  };

  const hide = () => {
    setVisible(false);
    setSelectedOrder(null);
    dispatch(reset());
  };

  const fetchEmployee = async () => {
    const isAdmin = location.pathname.includes("admin");
    const params = {
      admin: isAdmin,
      branchId: activePatient.branch,
      id: activePatient.staff_worker_in_charge_id,
    };
    let response = await getEmployee(params);
    const name = getFullName(response.data.surename, response.data.first_name);
    const role = professionalRoles.filter(
      (item) => item.id === response.data.professional_role_id
    )[0];
    const roleName = role?.name || "";
    setEmployeeName(name);
    setEmployeeRole(roleName);
  };

  const handlePrintTrom = async (record) => {
    const branch = userBranches.filter(
      (i) => i.id === record["patient.branch_id"]
    )[0];
    const serviceType =
      serviceTypes.filter((i) => i.id === record.order_service_type_id)[0] ||
      {};
    if (activePatient.staff_worker_in_charge_id) {
      await fetchEmployee();
    }
    const pdf = await getStartOfTromFile(
      record,
      mainContact,
      type,
      employeeName,
      employeeRole,
      serviceType.name,
      organization,
      branch,
      intl
    );
    window.open(pdf.output("bloburl"), "_blank");
  };

  const handlePrintOrder = (record) => {
    setSelectedOrder(record);
    dispatch(
      setActiveOrder({
        record: record,
      })
    );
    setTimeout(() => printOrder(), 300);
  };
  const printOrder = useReactToPrint({
    pageStyle:
      "@page { size: auto; margin: 0mm; } @media print { body { -webkit-print-color-adjust: exact; padding: 40px !important; direction: rtl; } }",
    content: () => componentRef.current,
  });

  const handlePrintAppendixB = async (record) => {
    const schedulingItems = await listTromScheduling(record);
    const branch = userBranches.filter(
      (i) => i.id === record["patient.branch_id"]
    )[0];
    const pdf = await getReportedTromFile(
      record,
      schedulingItems,
      organization,
      branch,
      intl
    );
    window.open(pdf.output("bloburl"), "_blank");
  };

  const handleShowChangeLogs = async (record) => {
    setchangeLogVisible(true);
    const params = {
      orderId: record.id,
      patientId: activePatient.id,
      scopePrefix,
    };
    const logs = await getOrderChangelog(params);
    let sortedArray = logs.data.items.sort(
      (a, b) => moment(b.created_at).valueOf() - moment(a.created_at).valueOf()
    );
    setOrderChangeLogs(sortedArray);
    setSelectedOrder(record);
  };

  const listTromScheduling = async (record) => {
    const patientId = activePatient.id;
    const branchId = activePatient.branch;
    const listParams = {
      current: 1,
      pageSize: 100,
      query: {
        from: moment.utc(record.effective_from).format(),
        to: moment().endOf("day").format(),
        order_id: record.id,
        approved: true,
      },
      scopePrefix,
      patientId,
      branchId,
    };
    const { data } = await listScheduling(listParams);
    const { items } = data;
    setTromScheduling(items);
    return items;
  };
  const Actions = () => {
    const ordersWithoutSupportingCommunity = sortedItems.filter(
      (j) => !j?.order_service_type?.supporting_community
    );
    return (
      <div style={{ display: "flex" }}>
        {ordersWithoutSupportingCommunity?.length > 0 && (
          <Button
            style={{ margin: "0 10px" }}
            type="primary"
            onClick={onEditPlanClick}
            size="large"
          >
            {<FormattedMessage id="app.orders.editPlan" />}
          </Button>
        )}

        <Button
          style={{ margin: "0 10px" }}
          type="text"
          onClick={onAddClick}
          size="large"
        >
          {<FormattedMessage id="app.orders.addNewOrder" />}
        </Button>
      </div>
    );
  };

  const onDeleteOrder = (record) => {
    const title = intl.formatMessage({
      id: "app.orders.deleteOrderTitle",
    });

    const content = intl.formatMessage({
      id: record.has_events
        ? "app.orders.deleteOrderWithHistoryContent"
        : "app.orders.deleteOrderContent",
    });
    modal.confirm({
      title: title,
      icon: <ExclamationCircleOutlined />,
      content: content,
      onOk() {
        return onConfirm(record);
      },
      onCancel() {},
    });
  };
  const onConfirm = async (record) => {
    const params = {
      scopePrefix,
      id: record.id,
      patientId: activePatient.id,
    };
    const action = await dispatch(removeOrder(params));
    if (!action.error) {
      dispatch(loadPage());
    }
  };

  const handleMenuClick = (e, record) => {
    switch (e.key) {
      case "1":
        onEditClicked(record);
        break;
      case "2":
        onShowPlanClicked(record);
        break;
      case "3":
        onEndOrderClicked(record);
        break;
      case "4":
        handlePrintOrder(record);
        break;
      case "5":
        onDuplicateClicked(record);
        break;
      case "6":
        onSendStartOfTrom(record);
        break;
      case "7":
        handlePrintTrom(record);
        break;
      case "8":
        onSendAppendixB(record);
        break;
      case "9":
        handlePrintAppendixB(record);
        break;
      case "10":
        handleShowChangeLogs(record);
        break;
      case "11":
        onDeleteOrder(record);
        break;
      default:
        onEditClicked(record);
        break;
    }
  };
  const empty =
    (total === 0 || total === undefined) &&
    !loading &&
    (filter.freeText === "" || !filter.freeText);

  const getItems = (record) => {
    return [];
  };
  const getMenuItems = (record) => {
    let items = [
      {
        label: intl.formatMessage({
          id: "app.orders.editOrder",
        }),
        key: "1",
        icon: <EditOutlined />,
      },
      {
        label: intl.formatMessage({
          id: "app.orders.showPlan",
        }),
        key: "2",
        icon: <CalendarOutlined />,
      },
      {
        label: intl.formatMessage({
          id: "app.orders.printOrder",
        }),
        key: "4",
        icon: <PrinterOutlined />,
      },

      {
        label: intl.formatMessage({
          id: "app.orders.duplicate",
        }),
        key: "5",
        icon: <CopyOutlined />,
      },
      {
        label: intl.formatMessage({
          id: "app.orders.showChangeLogs",
        }),
        key: "10",
        icon: <ScheduleOutlined />,
      },
    ];

    if (!record.effective_to) {
      items.push({
        label: intl.formatMessage({
          id: "app.orders.endOrder",
        }),
        key: "3",
        icon: <FileDoneOutlined />,
      });
    }

    if (
      record["client.category.is_trom"] &&
      record["client.category.is_trom"] === true &&
      record["trom_target_client.email"]
    ) {
      items.push({
        label: intl.formatMessage({
          id: "app.orders.sendStartOfTrom",
        }),
        key: "6",
        icon: <MailOutlined />,
      });
    }

    if (
      record["client.category.is_trom"] &&
      record["client.category.is_trom"] === true
    ) {
      items.push({
        label: intl.formatMessage({
          id: "app.orders.printStartOfTrom",
        }),
        key: "7",
        icon: <PrinterOutlined />,
      });
    }

    if (
      (record["report_as_trom"] && record["client.email"]) ||
      (record["client.category.is_trom"] && record["trom_target_client.email"])
    ) {
      items.push({
        label: intl.formatMessage({
          id: "app.orders.sendTromScheduling",
        }),
        key: "8",
        icon: <MailOutlined />,
      });
    }

    if (record["report_as_trom"] || record["client.category.is_trom"]) {
      items.push({
        label: intl.formatMessage({
          id: "app.orders.printTromScheduling",
        }),
        key: "9",
        icon: <PrinterOutlined />,
      });
    }

    if (
      (record &&
        (!record.recurrent_work_events ||
          record.recurrent_work_events.length === 0)) ||
      (record["order_service_type.day_center"] === true &&
        record.has_approved_events === false)
    ) {
      items.push({
        label: intl.formatMessage({
          id: "app.orders.deleteOrder",
        }),
        key: "11",
        icon: <DeleteOutlined style={{ color: "red" }} />,
        style: { color: "red" },
      });
    }
    return items;
  };

  return (
    <div>
      {contextHolder}
      {empty ? (
        <EmptyState
          icon={<OrderImg />}
          onClick={onAddClick}
          buttonText={<FormattedMessage id="app.orders.addNewOrder" />}
          disabled={!activePatient.local_id_number}
        />
      ) : (
        <Surface>
          <ActionsTable
            borderless={true}
            tableItems={[
              {
                title: "activeStatus",
                width: "20px",
                render: ({ record }) =>
                  record.activeStatus ? (
                    <Badge status="success" />
                  ) : (
                    <Badge status="error" />
                  ),
              },
              {
                title: "category",
                responsive: ["xl"],
                render: ({ record }) => (
                  <OrderCategory
                    categoryName={record["client.category.name"]}
                  />
                ),
              },
              {
                title: "client",
                responsive: ["xl"],
                render: ({ record }) => {
                  return <Text>{record["client.name"]}</Text>;
                },
              },
              {
                title: "order_service_type",
                responsive: ["xl"],
                render: ({ record }) => {
                  return <Text>{record["order_service_type.name"]}</Text>;
                },
              },
              {
                title: "max_hours",
                responsive: ["xl"],
                render: ({ record }) => {
                  const totalDurationMinutes =
                    record?.recurrent_work_events?.reduce(
                      (sum, item) => sum + item.duration_minutes,
                      0
                    );
                  const totalDurationHours =
                    Math.round((totalDurationMinutes / 60) * 100) / 100;
                  return !record["order_service_type.supporting_community"] &&
                    !record["order_service_type.day_center"] ? (
                    <OrderHours record={record} />
                  ) : record["order_service_type.day_center"] ? (
                    <Badge
                      count={`${totalDurationHours}/${totalDurationHours}`}
                      style={{ backgroundColor: "#52c41a" }}
                    />
                  ) : null;
                },
              },
              {
                title: "service_type",
                responsive: ["xl"],
                render: OrderServiceType,
              },
              {
                title: "effective_from",
                responsive: ["md"],
                render: Date,
                columnProps: { format: "L" },
              },
              {
                title: "effective_to",
                responsive: ["xl"],
                render: ({ text }) => {
                  return text ? (
                    <Date text={text} format={"L"} />
                  ) : (
                    <Tag>
                      {intl.formatMessage({
                        id: `app.forms.order.no_end_date`,
                      })}
                    </Tag>
                  );
                },
                columnProps: { format: "L" },
              },
              {
                title: "options",
                responsive: ["md"],
                render: ({ record }) => {
                  const menuItems = getMenuItems(record);
                  return (
                    <div style={{ display: "flex" }}>
                      <Dropdown
                        trigger={["click"]}
                        menu={{
                          items: menuItems,
                          onClick: (e) => handleMenuClick(e, record),
                        }}
                      >
                        <Button type="link">
                          {intl.formatMessage({
                            id: "app.orders.options",
                          })}
                          <DownOutlined />
                        </Button>
                      </Dropdown>
                    </div>
                  );
                },
              },
            ]}
            ltrItems={[]}
            rowClassName={""}
            category={"orders"}
            current={current}
            pageSize={pageSize}
            total={total}
            loading={loading}
            textFilter={filter.freeText}
            reload={reload}
            loadPage={loadPage}
            skipInitialLoad={true}
            resetPage={resetPage}
            items={sortedItems}
            onTextChange={onTextChange}
            renderActions={<Actions />}
            headerInputPlaceholder={intl.formatMessage({
              id: "app.orders.typeClientName",
            })}
            showheader={true}
          />
        </Surface>
      )}
      <div
        style={{
          overflow: "hidden",
          height: 0,
          width: 0,
        }}
      >
        <div ref={componentRef}>
          <PrintOrder order={selectedOrder} />
        </div>
      </div>

      <Order
        type={type}
        onHide={hide}
        onConfirm={hide}
        selectedOrder={selectedOrder}
        visible={visible}
      />
      <EndOrderModal
        record={selectedOrder}
        onHide={onHideEndModal}
        visible={endModalVisible}
        activePatient={activePatient}
      />
      <OrderPlanModal
        record={selectedOrder}
        onHide={onHideOrderPlanModal}
        visible={orderPlanlVisible}
      />
      <StartOfTromModal
        record={selectedOrder}
        onHide={onHideStartOfTromModal}
        visible={startOfTromVisible}
      />
      <ReportedTromModal
        items={tromScheduling}
        record={selectedOrder}
        visible={reportedTromVisible}
        onHide={onHideReportedTrom}
      />
      <PlanModal onHide={onHidePlanModal} visible={planModalVisible} />
      <ChangeLogModal
        orderChangeLogs={orderChangeLogs}
        record={selectedOrder}
        onHide={onHideChangeLogModal}
        visible={changeLogVisible}
      />
    </div>
  );
};

export default Orders;
